import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { forwardRef, useContext } from 'react';
import { InteractiveListBaseItem } from './InteractiveListBaseItem.js';
import { jsx } from '@emotion/react';
import { LinkProviderContext } from '../LinkProvider/LinkProvider.js';
import { Box } from '../Box/Box.js';
import '@indeed/ifl-css';
import '../../utils/transition.js';
import '@indeed/ifl-icons';
import '../Text/Text.js';
import '../../utils/createResponsive.js';
import '../Flex/Flex.js';

const INTERACTIVE_LIST_LINK_DEFAULT_TAG = "a";
const InteractiveListLink = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    as = INTERACTIVE_LIST_LINK_DEFAULT_TAG,
    children,
    contentAfter,
    contentBefore,
    current = false,
    supportiveContent,
    ...remainingProps
  } = props;
  const {
    onClick: onClickFromContext
  } = useContext(LinkProviderContext);
  return jsx(Box, {
    as: "li",
    sx: {
      margin: 0,
      padding: 0,
      textIndent: 0,
      listStyleType: "none"
    }
  }, jsx(InteractiveListBaseItem, _extends({
    as: as,
    ref: ref,
    "aria-current": current ? "page" : undefined,
    current: current,
    contentAfter: contentAfter,
    contentBefore: contentBefore,
    supportiveContent: supportiveContent,
    onClick: onClickFromContext
  }, remainingProps), children));
});
InteractiveListLink.displayName = "InteractiveListLink";

export { InteractiveListLink };
